import { Button } from '@mui/material'
import { useCallback, useContext } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import { AppRoutes } from '../../../models'
import { InspectionWithRelated } from '../../../models/inspections'
import { ReplicacheContext } from '../../../providers/ReplicacheProvider/ReplicacheProvider'
import { updateInspectionCache } from '../../../replicache/mutateFunction'

export const CompleteInspectionButtonCached = ({
  inspection,
  disabled
}: {
  inspection: InspectionWithRelated
  disabled: boolean
}) => {
  const { replicacheInstance } = useContext(ReplicacheContext)
  const navigate = useNavigate()
  const { id } = useParams()

  const handleCompleteInspection = useCallback(async () => {
    if (!inspection) {
      return
    }
    const updatedEntry = {
      id: inspection.id!,
      info: {
        ...inspection.info!,
        finished: new Date()
      }
    }
    updateInspectionCache(updatedEntry, replicacheInstance)
    navigate(generatePath(AppRoutes.DVI_SINGLE_INSPECTION_SUMMARY, { id: id! }))
  }, [id, inspection, navigate, replicacheInstance])
  return (
    <Button
      variant="contained"
      fullWidth
      onClick={handleCompleteInspection}
      disabled={disabled}>
      Complete Inspection
    </Button>
  )
}
